import { useMutation } from "@tanstack/react-query";
import { fetchAPI } from "@coworker/app/src/hooks/API/tasks.service.helper";
import { CORE_SERVICE_URL } from "@coworker/app/src/hooks/API/core.service";

type UserToCreate = {
  roleId: string;
  emails: string[];
  teamId: string;
  storeId: string;
  status: string;
};

async function createUser(userToCreate: UserToCreate) {
  const url = `${CORE_SERVICE_URL}/atkomst/createFixaUser`;
  const response = await fetchAPI("POST", url, userToCreate);
  return response?.result;
}

export const useCreateUser = () =>
  useMutation({
    mutationFn: (userToCreate: UserToCreate) => createUser(userToCreate),
  });
